import * as yup from 'yup';

const schema = yup.object({
  from: yup.date().required(),
  to: yup.date().required(),
});

export default schema;
